import React from 'react';
import Script from 'next/script';
import { useAppSelector } from '@/redux';
import { useFeature } from '@/hooks';
import { FEATURES } from '@/constants/features';

export const AppleSignIn = (): React.JSX.Element => {
  const storeConf = useAppSelector(({ root }) => root.storeConf);
  const appleSignInFeatureEnabled = useFeature(storeConf, FEATURES.APPLE_SIGN_IN);

  return appleSignInFeatureEnabled && (
    <Script
      strategy="lazyOnload"
      src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/fr_FR/appleid.auth.js"
    />
  );
};

export default AppleSignIn;
